import React from 'react';
import Header from "../bundles/common/components/Header";
import Footer from "../bundles/common/components/Footer";
import { useMediaQuery, useTheme } from '@mui/material';
import Sidebar from "../bundles/common/components/Sidebar";

const Unauthorized = ({children}) => {
    const theme = useTheme();
    const isMediumOrLarger = useMediaQuery(theme.breakpoints.up('md'));

    return(
        <>
            <Header/>
            {children}
            {isMediumOrLarger?
                <Sidebar/>
                :
                <Footer/>
            }
        </>
    )
};

export default Unauthorized;
